import Choice from "@/components/fields/Choice";
import DOMPurify from "dompurify";
import {useAppState} from "@/store";

export default function PackingChoice({name, icon, label, onChange}) {
    const {state} = useAppState();
    return (
        <Choice
            type={"checkbox"}
            name={"packing"}
            value={name}
            checked={state.special?.items?.includes(name)}
            onChange={onChange}
            className={"md:!w-[33.33%] md:max-w-[176px] !h-auto aspect-square flex flex-col pt-[32px]"}
        >
            {icon}
            <span
                className={'text-small font-bold h-[64px] text-center flex items-center justify-center'}
                dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(label)}}
            />
        </Choice>
    )
}
